import { render, staticRenderFns } from "./from_sex_management.vue?vue&type=template&id=5cdbe4a4&scoped=true"
import script from "./from_sex_management.vue?vue&type=script&lang=js"
export * from "./from_sex_management.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_5qbk3fxidqh42wxgbx7uqb2gxe/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cdbe4a4",
  null
  
)

export default component.exports